import get from "lodash/get.js";
import toString from "lodash/toString.js";
import moment from "moment";
import Prefs from "./prefs.js";
import {
	PLANS,
	DEFAULT_SUBSCRIPTION_TYPE,
	PLANS_DETAILS,
	SUBSCRIPTION_PLAN_MAP
} from "./constants/subscriptionPlans.js";

import {account, preferences} from "./data/model/index.js";

/**
 * This function returns an empty array if the user doesn't have a host blacklist.
 */
const getHostBlacklistFromAccount = function (account: any): string[] {
	if (account && typeof account === "object" && Array.isArray(account.hostBlacklist))
		return account.hostBlacklist;
	else
		return [];
};

const getUuidFromAccount = function (account: account): string | undefined {
	if (account && typeof account === "object" && account.uuid)
		return account.uuid;
	else
		return undefined;
};

/**
 * @param  {Object} account
 * @return {Prefs} preferences
 */
const getPrefsFromAccount = function (account: any): preferences {
	if (account && typeof account === "object" && account.preferences && typeof account.preferences === "object")
		return new Prefs(account.preferences);
	else
		return new Prefs();
};

/**
 * @param  {Object} fallbackSubscription
 * @param  {Object} subscription
 * @return {Object} Subscription plans information
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'fallbackSubscription' implicitly has an... Remove this comment to see the full error message
const getSubscriptionPlansInfo = (fallbackSubscription, subscription = null) => {
	const subscriptionType = ((subscription && ((subscription as any).type)) ?? fallbackSubscription) || null;

	// @ts-expect-error FIXME
	let currentPlan = SUBSCRIPTION_PLAN_MAP[subscriptionType] || SUBSCRIPTION_PLAN_MAP[DEFAULT_SUBSCRIPTION_TYPE];

	// Special case: communities (this is not the most elegant thing but will do for now)
	// @ts-ignore FIXME
	if (subscription && subscription.type === "institutional_premium" && subscription?.details?.community_uuid !== undefined) {
		currentPlan = JSON.parse(JSON.stringify(currentPlan));
		currentPlan.current = PLANS.COMMUNITY;
	}

	let isExpired = false;

	if (
		subscription
    && (subscription as any).status !== "active"
    && typeof (subscription as any).status !== "undefined"
    && (subscription as any).expire_dt !== null
	) {
		isExpired = true;
		currentPlan = { ...currentPlan, availables: [PLANS.ANNUAL, PLANS.MONTHLY] };
	}

	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
	const expirationDate = subscription.expire_dt
	// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
				&& moment(subscription.expire_dt).format("MM/DD/YYYY");

	// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
	const price = get(subscription, "details.price", PLANS_DETAILS[currentPlan.current].price);

	return {
		isExpired,
		expirationDate,
		currentPlan: {
			// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
			...PLANS_DETAILS[currentPlan.current],
			type:  currentPlan.current,
			price: toString(price)
		},
		// @ts-expect-error TS(7006) FIXME: Parameter 'planKey' implicitly has an 'any' type.
		restOfPlans: currentPlan.availables.map(planKey => ({
			// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
			...PLANS_DETAILS[planKey],
			type: planKey
		}))
	};
};

export default {
	getHostBlacklistFromAccount,
	getUuidFromAccount,
	getPrefsFromAccount,
	getSubscriptionPlansInfo
};
